import axios from 'axios';
import jsonp from 'jsonp';
import $ from 'jquery';

const Request = {
    content: null,
    init: () => {
        Request.content = document.querySelector("#request");
        Request.contentOverlay = document.querySelector("#request-overlay");
        Request.requests = document.querySelectorAll(".request");
        Request.requestSubmit = document.querySelector("#request-submit");
        Request.requestError = document.querySelector("#request-error");
        Request.requestDone = document.querySelector("#request-done");

        Request.product = "";
        Request.bind();
    },
    bind: (e) => {
        if (Request.content) {
            [...Request.requests].forEach(request => {
                request.addEventListener("click", Request.open, true);
            });

            Request.requestSubmit.addEventListener("click", (e) => {
                Request.send();
            });

            Request.contentOverlay.addEventListener("click", (e) => {
                Request.close();
            });
        }
    },
    open: (e) => {
        let elem = e.target ? e.target : e.toElement;
        let product = elem.getAttribute("data-product");
        Request.product = product;
        Request.contentOverlay.classList.add("active");
        setTimeout(function() {
            Request.content.classList.add("active");
        }, 1000)
    },

    close: (e) => {
        Request.content.classList.remove("active");
        Request.contentOverlay.classList.remove("active");

    },

    send: (e) => {

        let error = false;
        let send = false;
        let firstName = document.querySelector("#txt-first-name").value;
        let lastName = document.querySelector("#txt-last-name").value;
        let company = document.querySelector("#txt-company").value;
        let email = document.querySelector("#txt-email").value;
        let catalogo = document.querySelector("#txt-catalogo").value;

        if (firstName.length == 0 && firstName.length < 2) {
            error = true;
        }

        if (lastName.length == 0 && lastName.length < 2) {
            error = true;
        }

        if (company.length == 0 && company.length < 2) {
            error = true;
        }

        if (email.length == 0 || !Request.validateEmail(email)) {
            error = true;
        }

        if (error) {
            Request.requestError.style.display = "block";
        } else {
            if (send == false) {
                $.ajax({
                    url: "https://www.ecstudio.com/wp/wp-json/custom_rest_api/v1/send_email",
                    type: 'POST',
                    crossDomain: true,
                    data: {
                        firstName: firstName,
                        lastName: lastName,
                        company: company,
                        catalogo: catalogo,
                        email: email
                    },
                    success: function(data) {
                        Request.requestError.style.display = "none";
                        Request.requestDone.style.display = "block";
                        Request.requestSubmit.disabled = true;
                        send = true;

                        setTimeout(function() {
                            Request.close();
                        }, 3500)
                    }
                });
            }


            //     axios.get("https://ecstudio.com/wp/wp-json/custom_rest_api/v1/send_email", {
            //             params: {
            //                 firstName: firstName,
            //                 lastName: lastName,
            //                 company: company,
            //                 catalogo: catalogo,
            //                 email: email
            //             }
            //         })
            //         .then(function(response) {
            //             Request.requestError.style.display = "none";
            //             Request.requestDone.style.display = "block";
            //             Request.requestSubmit.disabled = true;
            //             send = true;

            //             setTimeout(function() {
            //                 Request.close();
            //             }, 3500)
            //         })
            // }

        }
    },
    validateEmail: (email) => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return (true)
        }
        return (false)
    }

}
export default Request;